document.addEventListener('DOMContentLoaded', function() {
    const buyBoxBtn = document.querySelectorAll('.dtc-buy-box-redirect-insider .dtc-buy-box-redirect-insider__button--scroll');
    const buyBoxContainer = document.querySelector('.dtc-block-top-suplement-blog-box');

    if (!!!buyBoxBtn || !!!buyBoxContainer) return;

    buyBoxBtn.forEach(btn => {
        btn.addEventListener('click', function() {
            buyBoxContainer.scrollIntoView({ behavior: 'smooth' });
        })
    })
})